import Vue from "vue";
import Clipboard from "clipboard";
import { Message } from "element-ui";
import _ from "lodash";
/**
 * 清除登录信息
 */
export function clearLoginInfo() {
  let $u = Vue.prototype.$u;
  $u.store.commit($u.vuexConst.RESET_STATE);
}

/**
 * 复制到剪切板
 * @author miaoguoxin
 * @date 2020/9/9
 */

export function copyClipboard(text, event) {
  const btnId = "#" + event.currentTarget.id;
  const clipboard = new Clipboard(btnId, {
    text: function() {
      return text;
    }
  });
  clipboard.on("success", e => {
    Message({
      type: "success",
      message: "复制成功",
      duration: 1000,
      showClose: true
    });
    // 使用destroy可以清楚缓存
    clipboard.destroy();
  });
  clipboard.on("error", e => {
    Message({
      type: "error",
      message: "复制失败",
      duration: 1000,
      showClose: true
    });
    clipboard.destroy();
  });
}

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
export function difference(object, base) {
  function changes(object, base) {
    return _.transform(object, function(result, value, key) {
      if (!_.isEqual(value, base[key])) {
        result[key] =
          _.isObject(value) && _.isObject(base[key])
            ? changes(value, base[key])
            : value;
      }
    });
  }
  return changes(object, base);
}

export function isPropEqual(obj1, obj2) {
  // 如果其中没有对象
  if (!isObject(obj1) || !isObject(obj2)) {
    //值类型
    return obj1 === obj2;
  }
  // 如果特意传的就是两个指向同一地址的对象
  if (obj1 === obj2) {
    return true;
  }
  // 两个都是对象或者数组，而且不相等
  // 拿到对象key
  let obj1Keys = Object.keys(obj1);
  let obj2Keys = Object.keys(obj2);
  // 先判断长度就可以过滤一些
  if (obj1Keys.length !== obj2Keys.length) {
    return false;
  }
  // 以obj1为基准 和 obj2 一次递归比较
  for (let key in obj1) {
    // 递归比较当前每一项
    const res = isPropEqual(obj1[key], obj2[key]);
    // 如果碰到一个不一样的就返回 false
    if (!res) {
      // 跳出for循环
      return false;
    }
  }
  // 否则全相等
  return true;
}

function isObject(obj) {
  return typeof obj === "object" && obj !== null;
}
